import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/hotNews";
import { getCategory, formatViews } from "@/utils/content";

export default function NewsCard({ item }: { item: NewsItem }) {
  const cat = getCategory(item.categoryId);
  return (
    <article className="group card-surface overflow-hidden transition-transform duration-300 hover:-translate-y-1">
      <Link to={`/news/detail/${item.slug}`} className="block">
        <div className="relative aspect-[3/2] w-full overflow-hidden bg-background-200">
          <img
            src={item.image}
            alt={`${item.title} - ${cat.name}热瓜新鲜事`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="chip absolute left-3 top-3 bg-background-50/90 px-2.5 py-1 text-xs font-bold text-primary-700 backdrop-blur">
            <i className={cat.icon}></i>
            {cat.name}
          </span>
        </div>
        <div className="p-4 md:p-5">
          <h3 className="line-clamp-2 text-base font-bold leading-snug group-hover:text-primary-700 transition-colors">
            {item.title}
          </h3>
          <p className="mt-2 line-clamp-2 text-sm text-foreground-600">{item.summary}</p>
          <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1">
              <i className="ri-time-line"></i>
              {item.date}
            </span>
            <span className="inline-flex items-center gap-1">
              <i className="ri-fire-line text-primary-600"></i>
              热度 {item.heat}
            </span>
            <span className="inline-flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {formatViews(item.views)}
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}